import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  // Settings - Company Details
  companyModal: false,
  clientModal: false,
  clientModalType: null,
  clientModalData: null,
  clientDeleteModal: false,
  clientActivateModal: false,
  brandModal: false,
  brandModalType: null,
  brandModalData: null,
  brandDeleteModal: false,
  brandActivateModal: false,
  addMarketModal: false,
  editMarketModal: false,
  editMarketModalData: null,
  deleteMarketModal: false,
  activateMarketModal: false,
  // Settings - User List
  userModalType: null,
  userModalData: null,
  userModal: false,
  deleteUserModal: false,
  activateUserModal: false,
  // Feeds - Feed Library
  feedModalType: "feed",
  selectPathModalKind: 'dynamicText', // Dynamic Text || Facebook
  selectPathModal: false,
  selectPathLoader: false,
  createFeedModal: false,
  addFieldModal: false,
  deleteAllModal: false,
  duplicateAllModal: false,
  duplicateCampaignLoader: false,
  // Campaigns - Ad Library
  createCampaignModal: false,
  deleteCampaignModal: false,
  editCampaignModal: false,
  // Creative
  duplicateSetModal: false,
  settingsModal: false,
  addCreativeModal: false,
  deleteCreativeModal: false,
  duplicateCreativeModal: false,
  duplicateNewSizeCreativeModal: false,
  addVersionModal: false,
  creativeFilterModal: false,
  commentModal: false,
  showcaseModal: false,
  showcaseModalLoader: false,
  fallbackModal: false,
  feedConnectionModal: false,
  feedConnectionLoader: false,
  targetUrlModal: false,
  // Template
  selectTemplateModal: false,
  figmaPluginModal: false,
  pluginLoader: false,
  // Campaigns - Facebook
  facebookModal: false,
  facebookPublishSuccessModal: false,
  // Campaigns - Fonts
  fontModal: false,
  // Folder 
  folderModal: false,
  deleteTableItemModal: false,
  editTableItemModal: false,
  // Publish
  publishScriptSuccModal: false,
  publishScriptErrModal: false,
  // DCM 
  selectDcmProfileModal: false,
  // Adform
  adformCredentialModal: false,
  // Facebook Catalog
  fbBusinessAuthModal: false,
  fbCreateCatalogModal: false,
}

const modalSlice = createSlice({
  name: "Modals",
  initialState,
  reducers: {
    resetModalState(state, action) {
      // Settings - Company Details
      state.companyModal= false;
      state.clientModal= false;
      state.clientModalType= null;
      state.clientModalData= null;
      state.clientDeleteModal= false;
      state.clientActivateModal= false;
      state.brandModal= false;
      state.brandModalType= null;
      state.brandModalData= null;
      state.brandDeleteModal= false;
      state.brandActivateModal= false;
      state.addMarketModal= false;
      state.editMarketModal= false;
      state.editMarketModalData= null;
      state.deleteMarketModal= false;
      state.activateMarketModal= false;
      // Settings - User List
      state.userModalType= null;
      state.userModalData= null;
      state.userModal= false;
      state.deleteUserModal= false;
      state.activateUserModal= false;
      // Feeds - Feed Library
      state.feedModalType= "feed";
      state.selectPathModalKind= 'dynamicText'; // Dynamic Text || Facebook
      state.selectPathModal= false;
      state.selectPathLoader= false;
      state.createFeedModal= false;
      state.addFieldModal= false;
      state.deleteAllModal= false;
      state.duplicateAllModal= false;
      state.duplicateCampaignLoader= false;
      // Campaigns - Ad Library
      state.createCampaignModal= false;
      state.deleteCampaignModal= false;
      state.editCampaignModal= false;
      // Creative
      state.duplicateSetModal= false;
      state.settingsModal= false;
      state.addCreativeModal= false;
      state.deleteCreativeModal= false;
      state.duplicateCreativeModal= false;
      state.duplicateNewSizeCreativeModal= false;
      state.addVersionModal= false;
      state.creativeFilterModal= false;
      state.commentModal= false;
      state.showcaseModal= false;
      state.showcaseModalLoader=false;
      state.fallbackModal= false;
      state.feedConnectionModal= false;
      state.feedConnectionLoader= false;
      state.targetUrlModal= false;
      // Template
      state.selectTemplateModal= false;
      state.figmaPluginModal= false;
      state.pluginLoader= false;
      // Campaigns - Facebook
      state.facebookModal= false;
      state.facebookPublishSuccessModal= false;
      // Campaigns - Fonts
      state.fontModal= false;
      // Folder 
      state.folderModal= false;
      state.deleteTableItemModal= false;
      state.editTableItemModal= false;
      // Publish
      state.publishScriptSuccModal= false;
      state.publishScriptErrModal= false;
      // DCM 
      state.selectDcmProfileModal= false;
      // Adform
      state.adformCredentialModal= false;
      // Facebook Catalog
      state.fbBusinessAuthModal= false;
      state.fbCreateCatalogModal= false;
    },
    // Settings - Company Details
    toggleCompanyModal(state) {
      state.companyModal = !state.companyModal;
    },
    toggleClientModal(state) {
      state.clientModal = !state.clientModal;
    },
    setClientModalType(state, action) {
      state.clientModalType = action.payload;
    },
    setClientModalData(state, action) {
      state.clientModalData = action.payload;
    },
    toggleClientDeleteModal(state) {
      state.clientDeleteModal = !state.clientDeleteModal;
    },
    toggleClientActivateModal(state) {
      state.clientActivateModal = !state.clientActivateModal;
    },
    toggleBrandModal(state) {
      state.brandModal = !state.brandModal;
    },
    setBrandModalType(state, action) {
      state.brandModalType = action.payload;
    },
    setBrandModalData(state, action) {
      state.brandModalData = action.payload;
    },
    toggleBrandDeleteModal(state) {
      state.brandDeleteModal = !state.brandDeleteModal;
    },
    toggleBrandActivateModal(state) {
      state.brandActivateModal = !state.brandActivateModal;
    },
    toggleAddMarketModal(state) {
      state.addMarketModal = !state.addMarketModal;
    },
    toggleEditMarketModal(state) {
      state.editMarketModal = !state.editMarketModal;
    },
    setEditMarketModalData(state, action) {
      state.editMarketModalData = action.payload;
    },
    // Settings - User List
    setUserModalType(state, action) {
      state.userModalType = action.payload;
    },
    setUserModalData(state, action) {
      state.userModalData = action.payload;
    },
    toggleDeleteMarketModal(state) {
      state.deleteMarketModal = !state.deleteMarketModal;
    },
    toggleActivateMarketModal(state) {
      state.activateMarketModal = !state.activateMarketModal;
    },
    toggleUserModal(state) {
      state.userModal = !state.userModal;
    },
    toggleDeleteUserModal(state) {
      state.deleteUserModal = !state.deleteUserModal;
    },
    toggleActivateUserModal(state) {
      state.activateUserModal = !state.activateUserModal;
    },
    // Feeds - Feed Library
    toggleSelectPathModal(state) {
      state.selectPathModal = !state.selectPathModal;
    },
    toggleSelectPathLoader(state) {
      state.selectPathLoader = !state.selectPathLoader;
    },
    toggleCreateFeedModal(state) {
      state.createFeedModal = !state.createFeedModal;
    },
    toggleAddFieldModal(state) {
      state.addFieldModal = !state.addFieldModal;
    },
    setFeedModalType(state, action) {
      state.feedModalType = action.payload;
    },
    setSelectPathModalKind(state, action) {
      state.selectPathModalKind = action.payload;
    },
    toggleDeleteAllModal(state) {
      state.deleteAllModal = !state.deleteAllModal;
    },
    toggleDuplicateAllModal(state) {
      state.duplicateAllModal = !state.duplicateAllModal;
    },
    setDuplicateCampaignLoader(state, action) {
      state.duplicateCampaignLoader = action.payload;
    },
    // Campaigns - Ad Library 
    toggleCreateCampaignModal(state) {
      state.createCampaignModal = !state.createCampaignModal;
    },
    toggleDeleteCampaignModal(state) {
      state.deleteCampaignModal = !state.deleteCampaignModal;
    },
    toggleEditCampaignModal(state) {
      state.editCampaignModal = !state.editCampaignModal;
    },
    // Version - Creatives
    toggleDuplicateSetModal(state) {
      state.duplicateSetModal = !state.duplicateSetModal;
    },
    toggleSettingsModal(state) {
      state.settingsModal = !state.settingsModal;
    },
    toggleAddCreativeModal(state) {
      state.addCreativeModal = !state.addCreativeModal;
    },
    toggleDeleteCreativeModal(state) {
      state.deleteCreativeModal = !state.deleteCreativeModal;
    },
    toggleDuplicateCreativeModal(state) {
      state.duplicateCreativeModal = !state.duplicateCreativeModal;
    },
    toggleDuplicateNewSizeCreativeModal(state) {
      state.duplicateNewSizeCreativeModal = !state.duplicateNewSizeCreativeModal;
    },
    toggleAddVersionModal(state) {
      state.addVersionModal = !state.addVersionModal;
    },
    toggleCreativeFilterModal(state) {
      state.creativeFilterModal = !state.creativeFilterModal;
    },
    toggleCommentModal(state) {
      state.commentModal = !state.commentModal;
    },
    toggleShowcaseModal(state) {
      state.showcaseModal = !state.showcaseModal;
    },
    setShowcaseModalLoader(state, action) {
      state.showcaseModalLoader = action.payload;
    },
    toggleFallbackModal(state) {
      state.fallbackModal = !state.fallbackModal;
    },
    toggleFeedConnectionModal(state) {
      state.feedConnectionModal = !state.feedConnectionModal;
    },
    toggleFeedConnectionLoader(state) {
      state.feedConnectionLoader = !state.feedConnectionLoader;
    },
    toggleTargetUrlModal(state) {
      state.targetUrlModal = !state.targetUrlModal;
    },
    // Template
    toggleSelectTemplateModal(state) {
      state.selectTemplateModal = !state.selectTemplateModal;
    },
    toggleFigmaPluginModal(state, action) {
      if (action.payload !== undefined) {
        state.figmaPluginModal = action.payload;
      } else {
        state.figmaPluginModal = !state.figmaPluginModal;
      }
    },
    togglePluginLoader(state) {
      state.pluginLoader = !state.pluginLoader;
    },
    toggleNameYourTemplateModal(state) {
      state.nameYourTemplateModal = !state.nameYourTemplateModal;
    },
    // Campaigns - Facebook
    toggleFacebookModal(state) {
      state.facebookModal = !state.facebookModal;
    },
    toggleFacebookPublishSuccessModal(state) {
      state.facebookPublishSuccessModal = !state.facebookPublishSuccessModal;
    },
    // Campaign - Fonts
    toggleFontModal(state) {
      state.fontModal = !state.fontModal
    },
    // Folder
    toggleFolderModal(state) {
      state.folderModal = !state.folderModal;
    },
    toggleDeleteTableItemModal(state) {
      state.deleteTableItemModal = !state.deleteTableItemModal;
    },
    toggleEditTableItemModal(state) {
      state.editTableItemModal = !state.editTableItemModal;
    },
    // Publish
    togglePublishScriptSuccModal(state) {
      state.publishScriptSuccModal = !state.publishScriptSuccModal;
    },
    togglePublishScriptErrModal(state) {
      state.publishScriptErrModal = !state.publishScriptErrModal;
    },
    // DCM
    toggleSelectDcmProfileModal(state) {
      state.selectDcmProfileModal = !state.selectDcmProfileModal;
    },
    // Adform
    toggleAdformCredentialModal(state) {
      state.adformCredentialModal = !state.adformCredentialModal;
    },
    // Facebook Catalog
    toggleFbBusinessAuthModal(state) {
      state.fbBusinessAuthModal = !state.fbBusinessAuthModal;
    },
    toggleFbCreateCatalogModal(state) {
      state.fbCreateCatalogModal = !state.fbCreateCatalogModal;
    }
  }
});

export const {
  resetModalState,
  // Settings - Company Details
  toggleCompanyModal,
  toggleClientModal,
  setClientModalType,
  setClientModalData,
  toggleClientDeleteModal,
  toggleClientActivateModal,
  toggleBrandModal,
  setBrandModalType,
  setBrandModalData,
  toggleBrandDeleteModal,
  toggleBrandActivateModal,
  toggleAddMarketModal,
  toggleEditMarketModal,
  toggleActivateMarketModal,
  setEditMarketModalData,
  // Settings - User List
  setUserModalType,
  setUserModalData,
  toggleDeleteMarketModal,
  toggleUserModal,
  toggleDeleteUserModal,
  toggleActivateUserModal,
  // Feeds - Feed Library
  toggleSelectPathModal,
  toggleSelectPathLoader,
  toggleCreateFeedModal,
  toggleAddFieldModal,
  setFeedModalType,
  setSelectPathModalKind,
  toggleDeleteAllModal,
  toggleDuplicateAllModal,
  setDuplicateCampaignLoader,
  // Campaigns - Ad Library
  toggleCreateCampaignModal,
  toggleDeleteCampaignModal, 
  toggleEditCampaignModal,
  // Creatives
  toggleDuplicateSetModal,
  toggleSettingsModal,
  toggleAddCreativeModal,
  toggleDeleteCreativeModal,
  toggleDuplicateCreativeModal,
  toggleDuplicateNewSizeCreativeModal,
  toggleAddVersionModal,
  toggleCreativeFilterModal,
  toggleCommentModal,
  toggleShowcaseModal,
  setShowcaseModalLoader,
  toggleFallbackModal,
  toggleFeedConnectionModal,
  toggleFeedConnectionLoader,
  toggleTargetUrlModal,
  // Template
  toggleSelectTemplateModal,
  toggleFigmaPluginModal,
  togglePluginLoader,
  toggleNameYourTemplateModal,
  // Campaigns - Facebook
  toggleFacebookModal,
  toggleFacebookPublishSuccessModal,
  // Activity
  toggleCreateActivityModal,
  // Campaign - Fonts
  toggleFontModal,
  // Folder
  toggleFolderModal,
  toggleDeleteTableItemModal,
  toggleEditTableItemModal,
  // Publish
  togglePublishScriptSuccModal,
  togglePublishScriptErrModal,
  // DCM
  toggleSelectDcmProfileModal,
  // Adform
  toggleAdformCredentialModal,
  // Facebook Catalog
  toggleFbBusinessAuthModal,
  toggleFbCreateCatalogModal
} = modalSlice.actions;

export default modalSlice.reducer;